import { render, staticRenderFns } from "./AccommodationAmenitiesForm.vue?vue&type=template&id=967088bc&scoped=true&"
import script from "./AccommodationAmenitiesForm.vue?vue&type=script&lang=ts&"
export * from "./AccommodationAmenitiesForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccommodationAmenitiesForm.vue?vue&type=style&index=0&id=967088bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967088bc",
  null
  
)

export default component.exports